import { format } from 'date-fns'

const today = new Date()
export const firstDateOfMonth = format(today, 'yyyy-MM-01')
